import { Injectable } from '@angular/core';
import { FetchPolicy } from '@apollo/client/core';
import { FilterParser } from '@core/filter-parser';
import { BusLookup, CreateBusLookup, UpdateBusLookup } from '@core/model/bus-lookup/bus-lookup';
import { PageFilter } from '@core/model/pagination/filter';
import { PageResult } from '@core/model/pagination/page-result';
import { LocalStorageDataService } from '@core/services/local-storage.service';
import { ObjectUtils, strictMap } from '@core/utils/object-utils';
import { AddBusLookupGQL, ArchiveBusLookupGQL, BusinessLookup, BusinessLookupFilterInput, GetBusLookupByCodeGQL, GetBusLookupGQL, GetBusLookupsByLookupCodeGQL,  GetBusLookupsByLookupModuleCodeFilterGQL,  GetBusLookupsByLookupModuleCodeGQL, GetBusLookupsByLookupModuleCodeWithOutParentIdGQL, GetBusLookupsByLookupModuleCodeWithParentIdGQL,  GetBusLookupsBySelectedInGQL,  GetBusLookupsGQL,    RestoreBusLookupGQL, States, UpdateBusLookupGQL } from '@generated/queries';
import { Apollo, gql } from 'apollo-angular';
import { plainToClass } from 'class-transformer';
import { debug } from 'console';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class TktLookupService {
  lookup$: Observable<PageResult<BusinessLookup>>;
  lookupWithParent$: Observable<PageResult<BusinessLookup>>;
  lookupWithIn$: Observable<PageResult<BusinessLookup>>;

  pageFilter: PageFilter = {
    pageIndex: 0,
    activeIndex: 1,
    take: 10,
    search: '',
    state: '',
  };
  vmFilters: BusinessLookupFilterInput;

  constructor(
    private paginatedLookup: GetBusLookupsByLookupCodeGQL,
    private getLookup: GetBusLookupGQL,
    private getLookupByCode: GetBusLookupByCodeGQL,
    private getLookups: GetBusLookupsGQL,
    private lookupAdd: AddBusLookupGQL,
    private lookupUpdate: UpdateBusLookupGQL,
    private lookupArchive: ArchiveBusLookupGQL,
    private lookupRestore: RestoreBusLookupGQL,
    private getBusLookupsByLookupModuleCode: GetBusLookupsByLookupModuleCodeGQL,
    private getBusLookupsByLookupModuleCodeWithOutParentId: GetBusLookupsByLookupModuleCodeWithOutParentIdGQL,
    private localStorageService: LocalStorageDataService,
    private apollo: Apollo,
    private getBusLookupsBySelectedIn: GetBusLookupsBySelectedInGQL,
    private getBusLookupsByLookupModuleCodeWithParentId: GetBusLookupsByLookupModuleCodeWithParentIdGQL,
    private getPaginatedBusinessLookupByFilter: GetBusLookupsByLookupModuleCodeFilterGQL,
    private busLookup:GetBusLookupGQL,
  ) { }

  getPaginatedLookups(
    filter: PageFilter
  ): Promise<PageResult<BusLookup>> {
    this.vmFilters = {
      or: [
        {
          name: {
            contains: filter.search.trim(),
          },
        },
        {
          code: {
            contains: filter.search.trim(),
          }
        },

      ],
    };
    const filters = FilterParser.parseFilter({
      state: filter.state,
    });
    if (!ObjectUtils.isObjEmpty(filters)) {
      this.vmFilters = {
        and: [filters],
      };
    }
    const paginationFilter = FilterParser.parsePageFilter(filter);
    return this.getPaginatedBusinessLookupByFilter
      .fetch(
        {
          filter: this.vmFilters,
          skip: paginationFilter.skip,
          take: paginationFilter.take,
        },
        {
          fetchPolicy: this.localStorageService.getFetchPolicy('busLookup') as FetchPolicy,
        }
      )
      .pipe(
        map(
          (x) => new PageResult<BusLookup>(x.data.paginatedBusinessLookups as any)
        )
      )
      .toPromise();
  }

  getLookupData(id: string, fetchPolicy?: any): Promise<BusLookup> {
       return this.getLookup
      .fetch(
        {
          id,
        },
        {
          fetchPolicy:
            fetchPolicy ??
            this.localStorageService.getFetchPolicy('busLookup'),
        }
      )
      .pipe(
        map((x) => plainToClass(BusLookup, x.data.paginatedBusinessLookups.items[0]))
      )
      .toPromise();
  }

  getLookupDataByCode(code: string, fetchPolicy?: any): Promise<BusLookup> {
    return this.getLookupByCode
      .fetch(
        {
          code,
        },
        {
          fetchPolicy:
            fetchPolicy ??
            this.localStorageService.getFetchPolicy('busLookup'),
        }
      )
      .pipe(
        map((x) => plainToClass(BusLookup, x.data.paginatedBusinessLookups.items[0]))
      )
      .toPromise();
  }

  addLookup(model: BusLookup): Promise<string> {
    console.log("create",JSON.stringify(model));
    return this.lookupAdd
      .mutate({ model: strictMap(CreateBusLookup, model) })
      .pipe(map((x) => x.data.business.busLookup.add))
      .toPromise();
  }

  updateLookup(model: BusLookup): Promise<string> {
    return this.lookupUpdate
      .mutate({ model: strictMap(UpdateBusLookup, model) })
      .pipe(map((x) => x.data.business.busLookup.update))
      .toPromise();
  }

  archiveLookup(id: string): Promise<string> {
    return this.lookupArchive
      .mutate({ lookupId: id })
      .pipe(map((x) => x.data.business.busLookup.archive))
      .toPromise();
  }

  restoreLookup(id: string): Promise<string> {
    return this.lookupRestore
      .mutate({ lookupId: id })
      .pipe(map((x) => x.data.business.busLookup.restore))
      .toPromise();
  }

  paginatedLookupByModuleCodeWithOutParent(event: boolean,lookupCode:string): Promise<PageResult<BusLookup>>  {
    if (event) {
      this.pageFilter.search = '';
      this.pageFilter.skip = 0;
    }
    return this.getBusLookupsByLookupModuleCodeWithOutParentId
      .fetch(
        {
          search: this.pageFilter.search,

          skip: this.pageFilter.skip,
          take: this.pageFilter.take,
          lookupModuleCode:lookupCode,
        },
        {
          fetchPolicy: 'network-only'
        }
      )
      .pipe(
        map(
          (x) => new PageResult<BusLookup>(x.data.paginatedBusinessLookups as any)
        )
      ).toPromise();


  }

  paginatedLookupByModuleCodeWithParent(event: boolean,lookupCode:string,status:States): Promise<PageResult<BusLookup>>  {
    if (event) {
      this.pageFilter.search = '';
      this.pageFilter.skip = 0;
    }
    return this.getBusLookupsByLookupModuleCodeWithParentId
      .fetch(
        {
          search: this.pageFilter.search,
          skip: this.pageFilter.skip,
          take: this.pageFilter.take,
          lookupModuleCode:lookupCode,
          status:status
        },
      )
      .pipe(
        map(
          (x) => new PageResult<BusLookup>(x.data.paginatedBusinessLookups as any)
        )
      ).toPromise();


  }

  fetchBussinessLookupByModuleCode(event: boolean,lookupCode:string): void {
    if (event) {
      this.pageFilter.search = '';
      this.pageFilter.skip = 0;
    }
    var lookup = this.getBusLookupsByLookupModuleCode
      .fetch(
        {
          search: this.pageFilter.search,
          skip: this.pageFilter.skip,
          take: this.pageFilter.take,
          lookupModuleCode:lookupCode,
        },
      )
      .pipe(
        map((x) => new PageResult<BusinessLookup>(x.data.paginatedBusinessLookups as any))
      );
      this.lookup$ = lookup;

  }

  fetchNextBussinessLookupByCode(event: number,lookupCode:string): void {
    this.pageFilter.skip = event;
    this.fetchBussinessLookupByModuleCode(false,lookupCode);
  }

  searchInBussinessLookupByCode(event: any,lookupCode:string): void {
    this.pageFilter.search = event.term;
    this.pageFilter.skip = null;
    this.fetchBussinessLookupByModuleCode(false,lookupCode);
  }

  fetchBussinessLookupByModuleCodeWithOutParent(event: boolean,lookupCode:string): void {
    if (event) {
      this.pageFilter.search = '';
      this.pageFilter.skip = 0;
    }
    var lookup = this.getBusLookupsByLookupModuleCodeWithOutParentId
      .fetch(
        {
          search: this.pageFilter.search,
          skip: this.pageFilter.skip,
          take: this.pageFilter.take,
          lookupModuleCode:lookupCode,
          parentId: null
        },
      )
      .pipe(
        map((x) => new PageResult<BusinessLookup>(x.data.paginatedBusinessLookups as any))
      );
      this.lookup$ = lookup;

  }

  fetchNextBussinessLookupByCodeWithOutParent(event: number,lookupCode:string): void {
    this.pageFilter.skip = event;
    this.fetchBussinessLookupByModuleCodeWithOutParent(false,lookupCode);
  }

  searchInBussinessLookupByCodeWithOutParent(event: any,lookupCode:string): void {
    this.pageFilter.search = event.term;
    this.pageFilter.skip = null;
    this.fetchBussinessLookupByModuleCodeWithOutParent(false,lookupCode);
  }

  setBusLookup(busLookupId: string) {
    const busLookup = this.busLookup
      .fetch(
        {
          id: busLookupId,
        },
        {
          fetchPolicy: this.localStorageService.getFetchPolicy('busLookup') as FetchPolicy,
        }
      )
      .pipe(map((x) => new PageResult<BusLookup>(x.data.paginatedBusinessLookups as any)));
    this.lookupWithParent$ = busLookup;
    return busLookup;
  }

  fetchBussinessLookupByModuleCodeWithParent(event: boolean,lookupCode:string,status: States = States.Active ): void {
    if (event) {
      this.pageFilter.search = '';
      this.pageFilter.skip = 0;
    }
    var lookup = this.getBusLookupsByLookupModuleCodeWithParentId
      .fetch(
        {
          search: this.pageFilter.search,
          skip: this.pageFilter.skip,
          take: 300,
          lookupModuleCode:lookupCode,
          parentId: null,
          status: status
        },
        {
          fetchPolicy: 'network-only'
        }
      )

      .pipe(
        map((x) => new PageResult<BusinessLookup>(x.data.paginatedBusinessLookups as any))
      );
      this.lookupWithParent$ = lookup;

  }

  fetchNextBussinessLookupByCodeWithParent(event: number,lookupCode:string): void {
    this.pageFilter.skip = event;
    this.fetchBussinessLookupByModuleCodeWithParent(false,lookupCode);
  }

  searchInBussinessLookupByCodeWithParent(event: any,lookupCode:string): void {
    this.pageFilter.search = event;
    this.pageFilter.skip = null;
    this.fetchBussinessLookupByModuleCodeWithParent(false,lookupCode);
  }

  fetchBussinessLookupWithIN(event: boolean,lookupIds:string[]): void {
    if (event) {
      this.pageFilter.search = '';
      this.pageFilter.skip = 0;
    }
    this.lookupWithIn$ = of(null);
    //this.lookupWithIn$ = new Observable<PageResult<BusinessLookup>>();
    var lookup = this.getBusLookupsBySelectedIn
      .fetch(
        {
          search: this.pageFilter.search,
          skip: this.pageFilter.skip,
          take: this.pageFilter.take,
          idList:lookupIds
        },
        {
          fetchPolicy: 'network-only'
        }
      )
      .pipe(
        map((x) => new PageResult<BusinessLookup>(x.data.paginatedBusinessLookups as any))
      );
      this.lookupWithIn$ = lookup;

  }

  fetchNextBussinessLookupWithIN(event: number,lookupCode:string[]): void {
    this.pageFilter.skip = event;
    this.fetchBussinessLookupWithIN(false,lookupCode);
  }

  searchInBussinessLookupWithIN(event: any,lookupCode:string[]): void {
    this.pageFilter.search = event.term;
    this.pageFilter.skip = null;
    this.fetchBussinessLookupWithIN(false,lookupCode);
  }


}
